import type { Pax } from '@libs/trip-planner-interfaces';

import type { CoreEventSource } from '../../models';

export enum PaxMutationType {
  UpdatePax = 'updatePax',
  ClearWarningMessages = 'clearWarningMessages',
}

export interface UpdatePaxMutation {
  type: PaxMutationType.UpdatePax;
  newPax: Pax;
  source?: CoreEventSource;
}

export interface ClearWarningMessagesMutation {
  type: PaxMutationType.ClearWarningMessages;
}

export type PaxMutation = UpdatePaxMutation | ClearWarningMessagesMutation;
